import createIcon from '../../createIcon';

/**
 * @component @name ModelTraining
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUuNSAxNC41QzE1LjUgMTYuNSAxMyAxOCAxMyAxOS41SDExQzExIDE4IDguNSAxNi41IDguNSAxNC41QzguNSAxMi41NyAxMC4wNyAxMSAxMiAxMUMxMy45MyAxMSAxNS41IDEyLjU3IDE1LjUgMTQuNVpNMTMgMjAuNUgxMVYyMkgxM1YyMC41Wk0xOSAxNEMxOSAxNS42OCAxOC40MSAxNy4yMSAxNy40MiAxOC40MkwxOC44NCAxOS44NEMyMC4xOCAxOC4yNyAyMSAxNi4yMyAyMSAxNEMyMSAxMS4yNiAxOS43NyA4LjgxIDE3Ljg0IDcuMTZMMTYuNDIgOC41OEMxNy45OSA5Ljg2IDE5IDExLjgyIDE5IDE0Wk0xNiA2TDEyIDJWNUM3LjAzIDUgMyA5LjAzIDMgMTRDMyAxNi4yMyAzLjgyIDE4LjI3IDUuMTYgMTkuODRMNi41OCAxOC40MkM1LjU5IDE3LjIxIDUgMTUuNjggNSAxNEM1IDEwLjE0IDguMTQgNyAxMiA3VjEwTDE2IDZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ModelTraining = createIcon('ModelTraining', [
  [
    'path',
    {
      d: 'M15.5 14.5C15.5 16.5 13 18 13 19.5H11C11 18 8.5 16.5 8.5 14.5C8.5 12.57 10.07 11 12 11C13.93 11 15.5 12.57 15.5 14.5ZM13 20.5H11V22H13V20.5ZM19 14C19 15.68 18.41 17.21 17.42 18.42L18.84 19.84C20.18 18.27 21 16.23 21 14C21 11.26 19.77 8.81 17.84 7.16L16.42 8.58C17.99 9.86 19 11.82 19 14ZM16 6L12 2V5C7.03 5 3 9.03 3 14C3 16.23 3.82 18.27 5.16 19.84L6.58 18.42C5.59 17.21 5 15.68 5 14C5 10.14 8.14 7 12 7V10L16 6Z',
      key: 'nq8czo',
    },
  ],
]);

export default ModelTraining;
